const isValidEmailFormat = (email) => {
    const regex = /^.*@\w+\.\w+.*$/;
    return regex.test(email);
};
const isValidPhoneFormat = (number) => {
    return !!number.match(/^((\+84|0)(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})$/);
};
const PATTERN_VALIDATION = {
    email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
    phone: /^([+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b$/,
    vietnameseName: /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s\w|_]+$/,
};

export { PATTERN_VALIDATION, isValidEmailFormat, isValidPhoneFormat };
